<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="영어단어의 의미를 파악합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="vx-row flex items-center justify-center">
        <div v-if="isShowImage" class="vx-col sm:w-1/2 lg:w-1/2 w-full mb-base">
          <vx-card class="flex items-center justify-center" style="height: 280px;">
            <img :src="content.image" alt="content-img" style="max-height:260px; width:200px" >
          </vx-card>
        </div>

        <div class="vx-col sm:w-1/2 lg:w-1/2 w-full mb-base">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card style="height:110px" class="flex items-center justify-center mb-3">
                  <p class="text-center sentence text-primary">{{ content.sentence }}</p>
              </vx-card>
            </div>
            <div class="vx-col w-full mb-4">
              <vx-card style="height:110px" class="flex items-center justify-center">
                  <p class="text-center sentence ">{{ content.translation }}</p>
              </vx-card>
            </div>
            <div class="vx-col w-full">
              <vs-input-number min="1" max="6" v-model="repeat" />
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col">
          <audio ref="audioPlayer" 
              controls 
              hidden
              v-on:ended="audioFinish" 
              controlsList="nodownload">Your browser does not support the <code>audio</code> element.
          </audio>
        </div>
        
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
//import StartStudy          from './StartStudy.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      isStart: false,
      contentList: [],
      contentIndex: 0,
      contentsLen: 0,
      repeat: 3,
      played: 0,
      finished: false,
      isShowImage: true
    }
  },
  watch: {
    
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.isStart = false
      this.contentIndex = 0
      this.played = 0
      this.startAlert()
    },
    onStart () {
      this.isStart = true
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      this.played++
      if (this.played >= this.repeat) {
        if (this.contentIndex === (this.contentsLen - 1)) {
          this.onComplete()
        } else {
          this.contentIndex = this.contentIndex + 1
          this.audioPlayer.src = this.content.audio
          this.played = 0
          this.audioPlayer.play()
        }
      } else {
        this.audioPlayer.play()
      }
    },
    startAlert () {
      this.startStudyDlg('영어단어의 의미를 파악합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    // 1,2 레벨만 이미지를 보여준다.
    const bookCode = this.sourceContent.bookCode
    const course = bookCode.substring(0, 2)
    const level = parseInt(bookCode.substring(4, 5))
    if ((course === 'SP' || course === 'TS') && level < 3) {
      this.isShowImage = true
    } else {
      this.isShowImage = false
    }

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1),
        image: this.$buildImagePath(this.sourceContent.contentCode, i)
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()
  },
  mounted () {
  }
}

</script>
